export default class ScrollAnimation{
    constructor(effect){

        this.effect = effect;

        this.$target = document.querySelectorAll('.js__tsc');
        this.scPoint = [];
        this.scNum = this.$target.length;

        let _splitText = document.getElementsByClassName("js__tsc-splittext");
        let _fade = document.getElementsByClassName("js__tsc-x");

        if(_splitText != null) this.effect.splitText(_splitText,"set");
        if(_fade != null) this.effect.fade(_fade,"set");
        this.resize();

        this.status = {
            comp : false /* 全部処理が終わったか */
        }

    }
    check(inc,winH){

        if(this.status.comp) return;

        let _minusPoint = (Useragnt.pc)?winH/1.5:winH;

        if(this.$target){
            for(var i=0; this.scNum>i; i++){
                if(this.scPoint[i] - _minusPoint < inc  ) {

                    let $scp = this.$target[i];
                    if(!$scp.classList.contains('is-show')){
                        $scp.classList.add("is-show");

                        let _splitText = $scp.querySelectorAll("js__tsc-splittext >* >*");
                        let _fade = $scp.querySelectorAll("js__tsc-x");

                        if(_splitText != null) this.effect.splitText(_splitText,"show");
                        if(_fade != null) this.effect.fade(_fade,"show");

                        if(i==this.$target.length-1) this.status.comp = true;

                    }

                }

            }

        }

    }

    resize () {

        if(this.$target){

            this.scPoint = [];
            for( var i=0; i<this.scNum; i++) {

                let $scp = this.$target[i];

                this.scPoint[i] = $scp.getBoundingClientRect().top;
            }
        }

    }
}